import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "defaultValue", "onChange"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Toggle/Toggle.js",
    _this = this;

import React, { useState } from 'react';
import { noop } from '@lux/helpers';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
var SwitchEffect = styled(withTheme(styled.div.withConfig({
  displayName: "Toggle__SwitchEffect",
  componentId: "sc-1351j2x-1"
})(["display:inline-block;position:absolute;box-sizing:border-box;transition:0.2s all ease-in;", ""], function (_ref) {
  var coreTheme = _ref.coreTheme;
  return css(["top:-", "px;left:-", "px;height:48px;width:48px;border-radius:48px;border:", "px solid transparent;border-color:", ";opacity:0;"], coreTheme.space_2, coreTheme.space_2, coreTheme.space_2, coreTheme.cl_sec_l1);
}))).withConfig({
  displayName: "Toggle__SwitchEffect",
  componentId: "sc-1351j2x-0"
})({});
var Label = styled.label.withConfig({
  displayName: "Toggle__Label",
  componentId: "sc-1351j2x-2"
})(["display:block;"]);
var ToggleWrapper = styled.div.withConfig({
  displayName: "Toggle__ToggleWrapper",
  componentId: "sc-1351j2x-3"
})(["display:inline-flex;align-items:center;position:relative;cursor:pointer;"]);
var Switch = withTheme(styled.div.withConfig({
  displayName: "Toggle__Switch",
  componentId: "sc-1351j2x-4"
})(["display:block;position:absolute;left:0;top:-4px;height:", "px;width:", "px;border-radius:", ";transition:0.2s all ease-in;", " :hover{", "{opacity:0.8;}}:active{", "{opacity:0.5;}}"], function (p) {
  return p.coreTheme.space_8;
}, function (p) {
  return p.coreTheme.space_8;
}, function (p) {
  return p.coreTheme.rad_xl;
}, function (p) {
  return css(["transform:", ";box-shadow:0 3px 8px 0 rgba(0 0 0 / 0.12);background-color:", ";"], p.value ? 'translate(24px)' : 0, p.value ? p.coreTheme.cl_sec_d1 : p.coreTheme.cl_ter_l4);
},
/* sc-selector */
SwitchEffect,
/* sc-selector */
SwitchEffect));
var Path = withTheme(styled.span.withConfig({
  displayName: "Toggle__Path",
  componentId: "sc-1351j2x-5"
})(["display:block;width:56px;height:24px;background-color:", ";border-radius:", ";transition:0.4s all ease;"], function (p) {
  return p.active ? p.coreTheme.cl_sec_l1 : p.coreTheme.cl_ter_l5;
}, function (p) {
  return p.coreTheme.rad_xl;
}));
var Checkbox = styled.input.withConfig({
  displayName: "Toggle__Checkbox",
  componentId: "sc-1351j2x-6"
})(["display:none;"]);

var Toggle = function Toggle(props) {
  var name = props.name,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setValue = _useState2[1];

  var toggleHandler = function toggleHandler() {
    setValue(!currentValue);
  };

  return /*#__PURE__*/React.createElement(Label, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ToggleWrapper, {
    onClick: function onClick() {
      return toggleHandler();
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Switch, {
    value: currentValue,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SwitchEffect, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Path, {
    active: currentValue,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Checkbox, _extends({
    type: "checkbox",
    name: name,
    value: currentValue,
    onChange: onChange
  }, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 7
    }
  })));
};

Toggle.defaultProps = {
  defaultValue: false,
  onChange: noop
};
export default Toggle;